<div
    class="control-container"
    [formGroup]="form"
    [hidden]="isHidden"
    [matTooltip]="control.icon ? '' : control.tooltip"
    matTooltipClass="mat-tooltip-cp no-margin"
    matTooltipPosition="above"
    matTooltipShowDelay="500"
>
    <ng-container *ngIf="dataSource$ | async; let dataSource">
        <se-autocomplete
            class="control"
            [required]="required"
            [disabled]="isDisabled"
            [dynamicAddEnabled]="false"
            [icon]="control.icon"
            [iconTooltip]="control.tooltip"
            [isOnError]="!formControl?.valid"
            [isWithLabel]="control.isWithLabel"
            [items]="dataSource"
            [placeholder]="control.isWithLabel ? placeholder : ''"
            [(value)]="model"
            (valueChange)="onValueChange($event)"
        >
        </se-autocomplete>
    </ng-container>
</div>
